/* ============================================================
   FOLKS HEADER — interacciones
   - scroll compacta el nav + colapsa announcement
   - announcement bar rotativa
   - megamenú hover/focus
   - search overlay con predictive search
   - mini-cart drawer con Section Rendering API
   - mobile overlay menu
   ============================================================ */
(function () {
  'use strict';

  const root = document.querySelector('.folks-header');
  if (!root) return;

  /* ---------- SCROLL state ---------- */
  let scrolled = false;
  const onScroll = () => {
    const next = window.scrollY > 24;
    if (next === scrolled) return;
    scrolled = next;
    root.querySelector('.fh-main').classList.toggle('fh-main--scrolled', scrolled);
    const annc = root.querySelector('.fh-annc');
    if (annc) annc.classList.toggle('fh-annc--collapsed', scrolled);
  };
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------- ANNOUNCEMENT rotator ---------- */
  const msgs = root.querySelectorAll('.fh-annc__msg');
  if (msgs.length > 1) {
    let i = 0;
    setInterval(() => {
      i = (i + 1) % msgs.length;
      msgs.forEach((m, idx) => {
        m.style.transform = `translateY(${(idx - i) * 100}%)`;
        m.setAttribute('aria-current', idx === i ? 'true' : 'false');
      });
    }, 4000);
  }

  /* ---------- MEGAMENU ---------- */
  const mega = root.querySelector('.fh-mega');
  const navLinks = root.querySelectorAll('.fh-link[data-cat]');
  const closeMega = () => {
    if (!mega) return;
    mega.dataset.open = 'false';
    mega.querySelectorAll('.fh-mega__panel').forEach(p => p.removeAttribute('data-current'));
    navLinks.forEach(l => l.setAttribute('aria-expanded', 'false'));
  };
  const openMega = (cat, link) => {
    if (!mega) return;
    mega.dataset.open = 'true';
    mega.querySelectorAll('.fh-mega__panel').forEach(p => {
      if (p.dataset.cat === cat) p.setAttribute('data-current', 'true');
      else p.removeAttribute('data-current');
    });
    navLinks.forEach(l => l.setAttribute('aria-expanded', l === link ? 'true' : 'false'));
    // pass accent to the megamenu via CSS var
    const accent = link?.style.getPropertyValue('--accent') || '#F4F0E6';
    mega.style.setProperty('--accent', accent);
  };
  navLinks.forEach(link => {
    link.addEventListener('mouseenter', () => openMega(link.dataset.cat, link));
    link.addEventListener('focus', () => openMega(link.dataset.cat, link));
    link.addEventListener('click', (e) => {
      // on desktop, the hover already opens; on click go to the link if href is set
      if (!link.getAttribute('href')) e.preventDefault();
    });
  });
  root.querySelector('.fh-main')?.addEventListener('mouseleave', closeMega);
  mega?.addEventListener('mouseleave', closeMega);

  /* ---------- SEARCH OVERLAY ---------- */
  const search = root.querySelector('.fh-search');
  const searchInput = search?.querySelector('.fh-search__input');
  const openSearch = () => {
    if (!search) return;
    search.dataset.open = 'true';
    document.body.style.overflow = 'hidden';
    setTimeout(() => searchInput?.focus(), 200);
  };
  const closeSearch = () => {
    if (!search) return;
    search.dataset.open = 'false';
    document.body.style.overflow = '';
  };
  root.querySelectorAll('[data-action="open-search"]').forEach(b => b.addEventListener('click', openSearch));
  root.querySelectorAll('[data-action="close-search"]').forEach(b => b.addEventListener('click', closeSearch));
  search?.addEventListener('click', (e) => { if (e.target === search) closeSearch(); });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeSearch(); closeCart(); closeMobileMenu(); }
  });

  // Predictive search
  const predictiveOut = search?.querySelector('[data-predictive]');
  let psDebounce = null;
  searchInput?.addEventListener('input', () => {
    clearTimeout(psDebounce);
    const q = searchInput.value.trim();
    if (!q) { if (predictiveOut) predictiveOut.hidden = true; return; }
    psDebounce = setTimeout(async () => {
      try {
        const r = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=4`);
        const data = await r.json();
        const products = data.resources?.results?.products || [];
        if (!predictiveOut) return;
        predictiveOut.hidden = false;
        predictiveOut.innerHTML = products.map(p => `
          <a href="${p.url}" class="fh-search__product">
            <img src="${p.image || ''}" alt="">
            <div>
              <div class="fh-search__product-name">${p.title}</div>
              <div class="fh-search__product-price">${p.price}</div>
            </div>
          </a>
        `).join('') || `<div style="color:var(--mute);font-size:14px;">Sin resultados para "${q}"</div>`;
      } catch (err) { /* fail silently */ }
    }, 220);
  });

  /* ---------- MINI-CART — delegated to FolksCartDrawer ---------- */
  const cartCountEls = root.querySelectorAll('[data-cart-count]');

  const openCart  = () => window.FolksCart?.open();
  const closeCart = () => window.FolksCart?.close();

  root.querySelectorAll('[data-action="open-cart"]').forEach(b => b.addEventListener('click', (e) => {
    e.preventDefault();
    window.FolksCart?._refreshFromAPI().then(() => openCart());
  }));

  async function updateCartBadge() {
    try {
      const data = await (await fetch('/cart.js')).json();
      cartCountEls.forEach(el => {
        el.textContent = data.item_count;
        el.style.display = data.item_count > 0 ? '' : 'none';
      });
    } catch (_) { /* ignore */ }
  }

  document.addEventListener('cart:added', () => { updateCartBadge(); openCart(); });

  /* ---------- MOBILE MENU ---------- */
  const mmenu = root.querySelector('.fh-mobile-menu');
  const burger = root.querySelector('.fh-burger');
  const openMobileMenu = () => {
    if (!mmenu) return;
    mmenu.dataset.open = 'true';
    burger && (burger.dataset.open = 'true');
    document.body.style.overflow = 'hidden';
    document.documentElement.style.background = '#1A2E26';
  };
  const closeMobileMenu = () => {
    if (!mmenu) return;
    mmenu.dataset.open = 'false';
    burger && (burger.dataset.open = 'false');
    document.body.style.overflow = '';
    document.documentElement.style.background = '';
    // collapse expanded cats
    mmenu.querySelectorAll('.fh-mobile-menu__cat').forEach(c => c.removeAttribute('data-open'));
  };
  burger?.addEventListener('click', () => {
    mmenu?.dataset.open === 'true' ? closeMobileMenu() : openMobileMenu();
  });
  root.querySelectorAll('[data-action="close-mobile-menu"]').forEach(b => b.addEventListener('click', closeMobileMenu));
  root.querySelectorAll('[data-action="open-search-from-mobile"]').forEach(b => b.addEventListener('click', () => {
    closeMobileMenu();
    setTimeout(openSearch, 300);
  }));
  mmenu?.querySelectorAll('.fh-mobile-menu__cat-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const cat = btn.closest('.fh-mobile-menu__cat');
      const isOpen = cat?.dataset.open === 'true';
      mmenu.querySelectorAll('.fh-mobile-menu__cat').forEach(c => c.removeAttribute('data-open'));
      if (!isOpen && cat) cat.dataset.open = 'true';
    });
  });
})();
